module.exports = __webpack_public_path__ + "static/media/59.ee643e89.jpg";